module.exports = __webpack_public_path__ + "img/8.345860dc.png";